/**
 * Einstellungen für das JahresStatistikBarChart-Widget
 */
import React, { useState, useEffect } from 'react';

const JahresStatistikBarChartSettings = ({ config, onChange }) => {
  const [settings, setSettings] = useState({
    title: config.title || 'Jahresstatistik',
  });

  useEffect(() => {
    // Aktualisiere den State wenn sich die config ändert
    setSettings({
      title: config.title || 'Jahresstatistik',
    });
  }, [config]);

  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    setSettings(prevSettings => ({
      ...prevSettings,
      title: newTitle
    }));
    if (onChange) {
      onChange({
        ...config,
        title: newTitle
      });
    }
  };

  return (
    <div className="jahres-statistik-bar-chart-settings">
      <h3>Einstellungen für Jahresstatistik Balkendiagramm</h3>
      <div className="form-group">
        <label htmlFor="widget-title">Widget Titel:</label>
        <input
          id="widget-title"
          type="text"
          className="form-control"
          value={settings.title}
          onChange={handleTitleChange}
        />
      </div>
    </div>
  );
};

export default JahresStatistikBarChartSettings;
